import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/content-management`;

export const contentManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/:courseId/create`,
  edit: `${baseRoute}/:courseId/edit/:contentId`,
  view: `${baseRoute}/:courseId/view`,
} as const;

export type IContentManagementRouteParams = IExtractRouteParamMap<
  typeof contentManagementRoutesObj
>;

export const contentManagementPath = createPaths<
  typeof contentManagementRoutesObj,
  IContentManagementRouteParams
>(contentManagementRoutesObj);
